import { StyleSheet } from 'react-native';
import { Buttons } from 'src/theme-v2/buttons';

export const styles = StyleSheet.create({
  button: {
    backgroundColor: Buttons.primary.ButtonPrimaryBackgroundDefault,
  },
  buttonInner: {},
  buttonHover: {
    backgroundColor: Buttons.primary.ButtonPrimaryBackgroundHover,
  },
  buttonPressed: {
    backgroundColor: Buttons.primary.ButtonPrimaryBackgroundPressed,
  },
  buttonFocus: {
    backgroundColor: Buttons.primary.ButtonPrimaryBackgroundDefault,
  },
  buttonDisabled: {
    cursor: 'not-allowed',
    backgroundColor: Buttons.primary.ButtonPrimaryBackgroundDisable,
  },
  text: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 20,
    textAlign: 'center',
    color: Buttons.primary.ButtonPrimaryTextDefault,
  },
  textHover: { color: Buttons.primary.ButtonPrimaryTextDefault },
  textPressed: { color: Buttons.primary.ButtonPrimaryTextDefault },
  textFocus: { color: Buttons.primary.ButtonPrimaryTextDefault },
  textDisabled: {
    color: Buttons.primary.ButtonPrimaryTextDisable,
  },
  icon: {
    color: Buttons.primary.ButtonPrimaryTextDefault,
  },
  iconHover: {
    color: Buttons.primary.ButtonPrimaryTextDefault,
  },
  iconPressed: {
    color: Buttons.primary.ButtonPrimaryTextDefault,
  },
  iconDisabled: {
    color: Buttons.primary.ButtonPrimaryTextDisable,
  },
  iconFocus: {
    color: Buttons.primary.ButtonPrimaryTextDefault,
  },
});
